import React from "react";
import { Button } from "hui";
import { GA_CATEGORY } from "../constants";

const GQButton: React.FC<{ siteSource: string }> = ({ siteSource }) => (
  <Button
    small
    tag="a"
    color="primary"
    href="/get_quotes_simple"
    data-ga-category={GA_CATEGORY}
    data-ga-action={`${GA_CATEGORY} - Clicked Get Quotes`}
    data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
    data-label={'header-get-quotes'}
  >
    Get Quotes
  </Button>
);

export default GQButton;
